const color = [
  "primary",
  "primary-lighten-1",
  "gray-lighten-1",
  "gray-lighten-2",
  "surface",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle"
] as const

export default {
  "slots": {
    "root": "relative overflow-hidden w-full rounded-lg p-4 flex gap-2.5",
    "wrapper": "min-w-0 flex-1 flex flex-col",
    "title": "text-sm font-medium",
    "description": "text-sm opacity-90",
    "icon": "shrink-0 size-5",
    "avatar": "shrink-0",
    "avatarSize": "2xl",
    "actions": "flex flex-wrap gap-1.5 shrink-0",
    "close": "p-0"
  },
  "variants": {
    "color": {
      "primary": "",
      "primary-lighten-1": "",
      "gray-lighten-1": "",
      "gray-lighten-2": "",
      "surface": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": ""
    },
    "orientation": {
      "horizontal": {
        "root": "items-center",
        "actions": "items-center"
      },
      "vertical": {
        "root": "items-start",
        "actions": "items-start mt-2.5"
      }
    },
    "title": {
      "true": {
        "description": "mt-1"
      }
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-primary text-inverted"
      }
    },
    {
      "color": "primary-lighten-1" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-primary-lighten-1 text-inverted"
      }
    },
    {
      "color": "gray-lighten-1" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-gray-lighten-1 text-inverted"
      }
    },
    {
      "color": "gray-lighten-2" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-gray-lighten-2 text-inverted"
      }
    },
    {
      "color": "surface" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-surface text-inverted"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-secondary text-inverted"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-success text-inverted"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-info text-inverted"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-warning text-inverted"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-error text-inverted"
      }
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-primary ring ring-inset ring-primary/25"
      }
    },
    {
      "color": "primary-lighten-1" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-primary-lighten-1 ring ring-inset ring-primary-lighten-1/25"
      }
    },
    {
      "color": "gray-lighten-1" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-gray-lighten-1 ring ring-inset ring-gray-lighten-1/25"
      }
    },
    {
      "color": "gray-lighten-2" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-gray-lighten-2 ring ring-inset ring-gray-lighten-2/25"
      }
    },
    {
      "color": "surface" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-surface ring ring-inset ring-surface/25"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-secondary ring ring-inset ring-secondary/25"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-success ring ring-inset ring-success/25"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-info ring ring-inset ring-info/25"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-warning ring ring-inset ring-warning/25"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-error ring ring-inset ring-error/25"
      }
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-primary/10 text-primary"
      }
    },
    {
      "color": "primary-lighten-1" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-primary-lighten-1/10 text-primary-lighten-1"
      }
    },
    {
      "color": "gray-lighten-1" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-gray-lighten-1/10 text-gray-lighten-1"
      }
    },
    {
      "color": "gray-lighten-2" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-gray-lighten-2/10 text-gray-lighten-2"
      }
    },
    {
      "color": "surface" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-surface/10 text-surface"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-secondary/10 text-secondary"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-success/10 text-success"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-info/10 text-info"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-warning/10 text-warning"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-error/10 text-error"
      }
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-primary/10 text-primary ring ring-inset ring-primary/25"
      }
    },
    {
      "color": "primary-lighten-1" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-primary-lighten-1/10 text-primary-lighten-1 ring ring-inset ring-primary-lighten-1/25"
      }
    },
    {
      "color": "gray-lighten-1" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-gray-lighten-1/10 text-gray-lighten-1 ring ring-inset ring-gray-lighten-1/25"
      }
    },
    {
      "color": "gray-lighten-2" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-gray-lighten-2/10 text-gray-lighten-2 ring ring-inset ring-gray-lighten-2/25"
      }
    },
    {
      "color": "surface" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-surface/10 text-surface ring ring-inset ring-surface/25"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-secondary/10 text-secondary ring ring-inset ring-secondary/25"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-success/10 text-success ring ring-inset ring-success/25"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-info/10 text-info ring ring-inset ring-info/25"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-warning/10 text-warning ring ring-inset ring-warning/25"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-error/10 text-error ring ring-inset ring-error/25"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "text-inverted bg-inverted"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-highlighted bg-default ring ring-inset ring-default"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "text-highlighted bg-elevated/50"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "text-highlighted bg-elevated/50 ring ring-inset ring-accented"
      }
    }
  ],
  "defaultVariants": {
    "color": "primary" as typeof color[number],
    "variant": "solid" as typeof variant[number]
  }
}